import { render, staticRenderFns } from "./Redemptions.vue?vue&type=template&id=2cf4572e&"
import script from "./Redemptions.vue?vue&type=script&lang=js&"
export * from "./Redemptions.vue?vue&type=script&lang=js&"
import style0 from "./Redemptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports